import {IconButton, Stack, Typography} from '@mui/material';
import {Close} from '@mui/icons-material';
import {useTranslation} from 'react-i18next';
import {PlannerAnniversaryItem} from '../planner-item';
import {UserAvatar} from '../../shared/user-avatar';
import {translations} from '../../../../../../../../i18n/translations';

type PlannerAnniversaryItemMenuProps = {
  item: PlannerAnniversaryItem;
  onClose: () => void;
};

export function PlannerAnniversaryItemMenu({item, ...props}: PlannerAnniversaryItemMenuProps) {
  const {t} = useTranslation();

  const user = item.user;

  return (
    <Stack flexDirection="column" gap="4px">
      {/* -------------- HEADER -------------- */}
      <Stack flexDirection="row" alignItems="center" gap="5px">
        {/* --------- USER --------- */}
        {/* --- PICTURE --- */}
        <UserAvatar
          size="m"
          disableTooltip
          name={user.name}
          picture={user.picture}
          socialResponses={user.socialResponses}
        />
        {/* --- NAME --- */}
        <Typography
          sx={{
            flex: 1,
            fontWeight: 500,
            fontSize: '16px',
            color: 'primary.main',
            height: '32px',
            display: 'flex',
            alignItems: 'center',
            marginBottom: '2px',
          }}
        >
          {user.name}
        </Typography>

        {/* ------- CLOSE BUTTON ------- */}
        <IconButton sx={{width: 32, height: 32, color: 'gray.main'}} onClick={props.onClose}>
          <Close />
        </IconButton>
      </Stack>

      {/* -------------- BODY -------------- */}
      <Stack gap="12px">
        {/* ---- GROUP ----- */}
        <Stack gap="6px">
          {/* --- ANNIVERSARY --- */}
          <Typography
            sx={{
              fontSize: '14px',
              color: 'gray.main',
              fontWeight: 500,
            }}
          >
            {t(translations.planner.item_menu.anniversary.birthday)}
          </Typography>
          {/* --- BIRTHDAY --- */}
          <Typography
            sx={{
              fontSize: '14px',
              color: 'gray.main',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {t(translations.planner.item_menu.anniversary.born)}{' '}
            {user.birthday.format('D MMM YYYY')}
          </Typography>
          {/* --- AGE --- */}
          <Typography
            sx={{
              fontSize: '14px',
              color: 'gray.main',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {user.age} {t(translations.planner.item_menu.anniversary.years)}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}
